import moment from 'moment'

const generateWeeklyDate = (date) => {
  const current = moment(date).clone()
  const startDay = current.startOf('isoWeek').format('DD')
  const endDay = current.endOf('isoWeek').format('DD')
  const monthStart = current.startOf('isoWeek').format('MMM')
  const monthEnd = current.endOf('isoWeek').format('MMM')
  const year = current.format('YYYY')

  return `${monthStart} ${startDay} - ${monthEnd} ${endDay}, ${year}`
}

export default generateWeeklyDate
